import React from "react";

const TableHeader = ({ columns, currentSortColumn, handleSort }) => {
    return (
        <thead>
            <tr className="bg-[#FFFFFF] border-b rounded-lg border-[#DEDEDE] h-12">
                {columns.map((col, idx) => (
                    <th
                        key={idx}
                        scope="col"
                        colSpan={col.colSpan || 1}
                        className={`px-4 py-3 min-w-[${col.minWidth}] max-w-[${col.maxWidth}]`}>
                        <span
                            id={col.id}
                            data-testid={col.testId}
                            className={`flex items-center ${col.center ? "justify-center" : ""}`}
                            onClick={(e) => handleSort(e, col.sortKey)}>
                            <p className="text-[16px] font-medium leading-normal text-[#343434] 
                            pr-1 py-1 cursor-pointer"
                            >{col.label}</p>
                            {col.sortKey && (currentSortColumn.key === col.sortKey ? (
                                currentSortColumn.order === "asc" ? (
                                    <img
                                        src="/images/dropdown-icon.png"
                                        alt="asc"
                                        className="dropdown-downwords3 cursor-pointer"
                                    />
                                ) : (
                                    <img
                                        src="/images/dropdown-upwords.svg"
                                        alt="desc"
                                        className="dropdown-upwords3 cursor-pointer"
                                    />
                                )
                            ) : (
                                <img
                                    src="/images/dropdown-icon.png"
                                    alt="sort"
                                    className="dropdown-upwords3 cursor-pointer"
                                />
                            ))}
                        </span>
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default TableHeader;
